const BACKEND_URL="http://localhost:8080"
const appData = {
  BACKEND_URL
}
export default appData